export function useScrollTinymceTocHeadingToView() {
  const applyBackground = (el: Element) => {
    el.classList.add("bg-lexmea-selection-lightest");
    setTimeout(() => {
      el.classList.remove("bg-lexmea-selection-lightest");
    }, 2000);
  };

  const scrollAndApplyHeading = (node?: Element) => {
    if (!node) return;

    applyBackground(node);
    return node.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (event): void => {
    const tableOfContent: HTMLOListElement =
      document.querySelector("#tableOfContents")!;
    const tableOfContentId: string = tableOfContent?.id;
    const clickedElement = event.target as Element;
    if (!clickedElement) {
      return;
    }

    const elementParentNodeId = clickedElement.parentElement?.id;
    // stop if what was clicked is not in tableOfContent
    if (elementParentNodeId !== tableOfContentId) {
      return;
    }

    const clickedDataStyleAttribute = clickedElement.getAttribute("data-style");

    const tocNodesWithSameHeadings = tableOfContent.querySelectorAll(
      `[data-style='${clickedDataStyleAttribute}']`
    );

    // assume the toc is up to date - that means if the clicked heading is, for example,
    // the second element with data-style="heading2" then we scroll to the second element in the text with that style
    let offset = 0;
    for (let i = 0; i < tocNodesWithSameHeadings.length; i++) {
      if (tocNodesWithSameHeadings[i] === clickedElement) {
        offset = i;
        break;
      }
    }

    // assume headings are always direct children of the body
    const textNodesWithSameHeadings = document.querySelectorAll(
      `.mce-content-body > [data-style='${clickedDataStyleAttribute}']`
    );

    // scroll to the element at the same offset
    scrollAndApplyHeading(textNodesWithSameHeadings[offset]);
  };
}
